import API from 'services/api';

export const getReservationLanguages = () => {
  return API.get('api/root/languages').then(response => response?.data);
};
